/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFiles = sqliteTable('patient_files', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  appointment_id: text('appointment_id'),
  queue_id: text('queue_id'),
  encounter_id: text('encounter_id'),
  visit_id: text('visit_id'),
  kind: text('kind'),
  filename: text('filename'),
  url: text('url'),
  tag: text('tag'),
  mime_type: text('mime_type'),
  description: text('description'),
  starred: integer('starred'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
